import { actions } from '@/modules/SuiviInterventions/store/actions';
import { getters } from '@/modules/SuiviInterventions/store/getters';
import { mutations } from '@/modules/SuiviInterventions/store/mutations';
import { state } from '@/modules/SuiviInterventions/store/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { SuiviInterventionState } from './state';

const SuiviInterventionModule: Module<SuiviInterventionState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

export default SuiviInterventionModule;
export type { SuiviInterventionState };
